export const mediaConstants = {
  LIST_MEDIA_REQUEST: "LIST_MEDIA_REQUEST",
  LIST_MEDIA_SUCCESS: "LIST_MEDIA_SUCCESS",
  LIST_MEDIA_FAILURE: "LIST_MEDIA_FAILURE"
}
